import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportData";
import { TradeByProductsReportData } from "../types";

export const useTradeByProductsReportData = () => {
  const data = useSelector<StoreType, TradeByProductsReportData[] | undefined>(
    (s) => s.data.reports.exchbusiness.tradeByProducts.data
  );

  const dispatch = useDispatch();
  const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [
    dispatch,
  ]);

  return [data, dispatchLoadData] as [typeof data, typeof dispatchLoadData];
};
